import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  team: () => faker.company.name(),
  botAccessToken: '123',
  botUserId: '1234',
  token: '12345',
});
